module.exports = __webpack_public_path__ + "media/components/switch-units/static/preferences-0be9965c7b6bf179f474f928ac06e39a.svg";